module.exports = __webpack_public_path__ + "img/Cumulativecoverage.efd2410d.png";